module.exports = __webpack_public_path__ + "media/images/area-badges/move-better-1160ca1e669ade33d4d7c59f507c58da.svg";